import { useMutation } from "@apollo/client";
import { Modal } from "@aqar-app/react-ui";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import { PAUSE_LISTING, RESUME_LISTING } from "@/src/graphql/mutations/listing";
import { GET_OWNER_LISTINGS } from "@/graphql/queries/user";
import {
  GET_LISTING,
  GET_LISTING_FULL_DETAILS,
} from "@/graphql/queries/listing";

export const useListingStatusControl = ({ token, onSuccess, onError, id }) => {
  const refetchQueries = [
    {
      query: GET_OWNER_LISTINGS,
      context: { token },
      variables: {
        listing_id: parseInt(id),
        limit: 1,
      },
    },
    {
      query: GET_LISTING_FULL_DETAILS,
      context: { token },
      variables: {
        id,
      },
    },
    {
      query: GET_LISTING,
      variables: {
        id,
      }
    }
  ];

  const [pauseListing, { loading: pauseLoading }] = useMutation(PAUSE_LISTING, {
    context: { token },
    onCompleted: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      } else {
        Modal.open(
          <ClassicModal
            newDesign
            close={false}
            cancel={false}
            title="عقار"
            ok={{
              label: "حسنًا",
              cb: (e) => {
                Modal.close(e);
              },
            }}
            body={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <p style={{ maxWidth: "356px", textAlign: "center" }}>
                  {error.message}
                </p>
              </div>
            }
          />,
        )();
      }
    },
    refetchQueries,
  });

  const [resumeListing, { loading: resumeLoading }] = useMutation(
    RESUME_LISTING,
    {
      context: { token },
      onCompleted: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        } else {
          Modal.open(
            <ClassicModal
              newDesign
              close={false}
              cancel={false}
              title="عقار"
              ok={{
                label: "حسنًا",
                cb: (e) => {
                  Modal.close(e);
                },
              }}
              body={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <p style={{ maxWidth: "356px", textAlign: "center" }}>
                    {error.message}
                  </p>
                </div>
              }
            />,
          )();
        }
      },
      refetchQueries,
    },
  );

  const handlePauseListing = ({ id }) => {
    Modal.open(
      <ClassicModal
        newDesign
        close={false}
        title="إيقاف / إخفاء الوحدة"
        ok={{
          label: "تراجع",
          outline: false,
          cb: (e) => {
            Modal.close(e);
          },
        }}
        cancel={{
          label: "إيقاف",
          theme: "danger",
          loading: pauseLoading,
          cb: (e) => {
            pauseListing({
              variables: {
                id: parseInt(id),
              },
            });
            Modal.close(e);
          },
        }}
        body={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <p style={{ maxWidth: "356px", textAlign: "center" }}>
              {
                "سيتم إخفاء الإعلان من الظهور للمستخدمين (يمكنك إعادة تفعيل الإعلان من: حسابي > إعلاناتي > موقفة)"
              }
            </p>
          </div>
        }
      />,
    )();
  };

  const handleResumeListing = ({ id }) => {
    resumeListing({
      variables: {
        id: parseInt(id),
      },
    });
  };

  return {
    handlePauseListing,
    handleResumeListing,
    pauseLoading,
    resumeLoading,
  };
};
